/**
 * Empty State Component
 * Displays when no data is available
 */

import React from 'react';

const EmptyState = ({ icon = 'inbox', message = 'No data available' }) => {
  return (
    <div className="empty-state">
      <div className="empty-state-icon">
        <i className={`bi bi-${icon}`} style={{ fontSize: '3rem' }}></i>
      </div>
      <p className="text-muted">{message}</p>
    </div>
  );
};

export default EmptyState;
